import React from 'react';

import { LoadingType } from 'actions';
import Loader from 'components/Loader';
import { useAppSelector } from 'hooks/useAppSelector';
import Section from 'components/LoanPortal/Sections/Section';
import EmploymentsInformation from 'pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/EmploymentInformation/EmploymentInformation';
import { BorrowerRole } from 'enums/BorrowerRole';
import ContractorInformation from 'pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/ContractorInformation/ContractorInformation';
import { DashboardTabName } from 'enums/DashboardTabName';
import styles from 'pages/Dashboard/steps/InformationTabs/InformationTabs.module.scss';
import { getIsEmploymentSectionCompleted } from 'pages/Dashboard/steps/InformationTabs/AdditionalInformationTab/additionalInformation.utils';

const AdditionalInformationTab = () => {
  const loading = useAppSelector(
    (state) => state.loading[`${LoadingType.RequiredInformationUpdating}${DashboardTabName.AdditionalInformation}`],
  );
  const { variables: applicationVariables, dashboardAdditionalInfo } = useAppSelector((state) => state.application);
  const additionalTabProps = dashboardAdditionalInfo!;

  return loading ? (
    <Loader />
  ) : (
    <div className={styles.requiredInformationContainer}>
      <Section
        title={`${applicationVariables?.borrower_first_name}'s Employment Information`}
        subSectionStates={[
          {
            isExist:
              additionalTabProps.isBorrowerCurrentEmploymentsRequired ||
              additionalTabProps.isPartialBorrowerCurrentEmploymentsRequired ||
              additionalTabProps.isBorrowerPreviousEmploymentRequired ||
              additionalTabProps.isBorrowerEmploymentStatusInformationRequired,
            isCompleted: getIsEmploymentSectionCompleted(additionalTabProps, BorrowerRole.Borrower),
          },
        ]}
      >
        <EmploymentsInformation borrowerType={BorrowerRole.Borrower} />
      </Section>
      <Section
        title={`${applicationVariables?.coborrower_first_name}'s Employment Information`}
        subSectionStates={[
          {
            isExist:
              additionalTabProps.isCoBorrowerCurrentEmploymentsRequired ||
              additionalTabProps.isPartialCoBorrowerCurrentEmploymentsRequired ||
              additionalTabProps.isCoBorrowerPreviousEmploymentRequired ||
              additionalTabProps.isCoBorrowerEmploymentStatusInformationRequired,
            isCompleted: getIsEmploymentSectionCompleted(additionalTabProps, BorrowerRole.CoBorrower),
          },
        ]}
      >
        <EmploymentsInformation borrowerType={BorrowerRole.CoBorrower} />
      </Section>
      <Section
        title={'Contractor Information'}
        subSectionStates={[
          {
            isExist: additionalTabProps.isContractorEmploymentRequired,
            isCompleted: additionalTabProps.isContractorEmploymentCompleted,
          },
        ]}
      >
        <ContractorInformation />
      </Section>
    </div>
  );
};

export default AdditionalInformationTab;
